const JWT_TOKEN_KEY = "session";

export function getJwtToken() {
  return localStorage.getItem(JWT_TOKEN_KEY);
}

export function setJwtToken(token: string) {
  localStorage.setItem(JWT_TOKEN_KEY, token);
}
